<div class="row">
    <div class="col-12" *ngFor="let item of termsAndPrivacyData">
        <div class="header mt-3">{{item.header}}</div>
        <div class="body-content mt-2" [innerHTML]="item.content"></div>
    </div>
</div>